<script setup lang="ts">
import { computed } from 'vue'
import BaseSvgIcon from '@/components/Base/SvgIcon.vue'
import { useSwipeBackGesture } from '@/composables/useSwipeBackGesture'

// 固定圓鈕座標（px），落在既有 header 返回箭頭下方一點
const ANCHOR = { x: 32, y: 96 }

const { isActive: isActiveState } = useSwipeBackGesture()
const isActive = computed(() => isActiveState.value)
</script>

<template>
  <Teleport to="body">
    <transition name="fade">
      <div
        v-if="isActive"
        class="swipe-back-indicator"
        :style="{ left: `${ANCHOR.x}px`, top: `${ANCHOR.y}px` }"
      >
        <BaseSvgIcon
          iconName="prev-arrow"
          color="white"
        />
      </div>
    </transition>
  </Teleport>
</template>

<style scoped lang="scss">
.swipe-back-indicator {
  position: fixed;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: $--color-primary;
  pointer-events: none;
  z-index: $--swipe-back-indicator-z-index;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
